 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLDESCRIPTION from '@/components/xhtml/description'
 import XHTMLSS_US_ADULT_SIGNUP_FRONT from '@/components/xhtml/SS_US_adult_signup_front'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLFM03 from '@/components/xhtml/fm03'
 import XHTMLCONTENT from '@/components/xhtml/content'
 import XHTMLDED from '@/components/xhtml/ded'
 import XHTMLHALF from '@/components/xhtml/half'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH08 from '@/components/xhtml/ch08'
 import XHTMLCH09 from '@/components/xhtml/ch09'
 import XHTMLCH10 from '@/components/xhtml/ch10'
 import XHTMLCH11 from '@/components/xhtml/ch11'
 import XHTMLCH12 from '@/components/xhtml/ch12'
 import XHTMLCH13 from '@/components/xhtml/ch13'
 import XHTMLCH14 from '@/components/xhtml/ch14'
 import XHTMLCH15 from '@/components/xhtml/ch15'
 import XHTMLCH16 from '@/components/xhtml/ch16'
 import XHTMLCH17 from '@/components/xhtml/ch17'
 import XHTMLCH18 from '@/components/xhtml/ch18'
 import XHTMLCH19 from '@/components/xhtml/ch19'
 import XHTMLCH20 from '@/components/xhtml/ch20'
 import XHTMLCH21 from '@/components/xhtml/ch21'
 import XHTMLCH22 from '@/components/xhtml/ch22'
 import XHTMLCH23 from '@/components/xhtml/ch23'
 import XHTMLCH24 from '@/components/xhtml/ch24'
 import XHTMLCH25 from '@/components/xhtml/ch25'
 import XHTMLCH26 from '@/components/xhtml/ch26'
 import XHTMLCH27 from '@/components/xhtml/ch27'
 import XHTMLCH28 from '@/components/xhtml/ch28'
 import XHTMLCH29 from '@/components/xhtml/ch29'
 import XHTMLCH30 from '@/components/xhtml/ch30'
 import XHTMLCH31 from '@/components/xhtml/ch31'
 import XHTMLCH32 from '@/components/xhtml/ch32'
 import XHTMLCH33 from '@/components/xhtml/ch33'
 import XHTMLCH34 from '@/components/xhtml/ch34'
 import XHTMLCH35 from '@/components/xhtml/ch35'
 import XHTMLCH36 from '@/components/xhtml/ch36'
 import XHTMLCH37 from '@/components/xhtml/ch37'
 import XHTMLCH38 from '@/components/xhtml/ch38'
 import XHTMLCH39 from '@/components/xhtml/ch39'
 import XHTMLCH40 from '@/components/xhtml/ch40'
 import XHTMLCH41 from '@/components/xhtml/ch41'
 import XHTMLCH42 from '@/components/xhtml/ch42'
 import XHTMLCH43 from '@/components/xhtml/ch43'
 import XHTMLCH44 from '@/components/xhtml/ch44'
 import XHTMLCH45 from '@/components/xhtml/ch45'
 import XHTMLCH46 from '@/components/xhtml/ch46'
 import XHTMLCH47 from '@/components/xhtml/ch47'
 import XHTMLCH48 from '@/components/xhtml/ch48'
 import XHTMLCH49 from '@/components/xhtml/ch49'
 import XHTMLCH50 from '@/components/xhtml/ch50'
 import XHTMLCH51 from '@/components/xhtml/ch51'
 import XHTMLCH52 from '@/components/xhtml/ch52'
 import XHTMLCH53 from '@/components/xhtml/ch53'
 import XHTMLCH54 from '@/components/xhtml/ch54'
 import XHTMLCH55 from '@/components/xhtml/ch55'
 import XHTMLCH56 from '@/components/xhtml/ch56'
 import XHTMLCH57 from '@/components/xhtml/ch57'
 import XHTMLCH58 from '@/components/xhtml/ch58'
 import XHTMLCH59 from '@/components/xhtml/ch59'
 import XHTMLCH60 from '@/components/xhtml/ch60'
 import XHTMLCH61 from '@/components/xhtml/ch61'
 import XHTMLCH62 from '@/components/xhtml/ch62'
 import XHTMLCH63 from '@/components/xhtml/ch63'
 import XHTMLCH64 from '@/components/xhtml/ch64'
 import XHTMLCH65 from '@/components/xhtml/ch65'
 import XHTMLCH66 from '@/components/xhtml/ch66'
 import XHTMLCH67 from '@/components/xhtml/ch67'
 import XHTMLCH68 from '@/components/xhtml/ch68'
 import XHTMLCH69 from '@/components/xhtml/ch69'
 import XHTMLCH70 from '@/components/xhtml/ch70'
 import XHTMLCH71 from '@/components/xhtml/ch71'
 import XHTMLCH72 from '@/components/xhtml/ch72'
 import XHTMLCH73 from '@/components/xhtml/ch73'
 import XHTMLCH74 from '@/components/xhtml/ch74'
 import XHTMLCH75 from '@/components/xhtml/ch75'
 import XHTMLCH76 from '@/components/xhtml/ch76'
 import XHTMLCH77 from '@/components/xhtml/ch77'
 import XHTMLCH78 from '@/components/xhtml/ch78'
 import XHTMLCH79 from '@/components/xhtml/ch79'
 import XHTMLCH80 from '@/components/xhtml/ch80'
 import XHTMLCH81 from '@/components/xhtml/ch81'
 import XHTMLCH82 from '@/components/xhtml/ch82'
 import XHTMLCH83 from '@/components/xhtml/ch83'
 import XHTMLCH84 from '@/components/xhtml/ch84'
 import XHTMLCH85 from '@/components/xhtml/ch85'
 import XHTMLCH86 from '@/components/xhtml/ch86'
 import XHTMLCH87 from '@/components/xhtml/ch87'
 import XHTMLCH88 from '@/components/xhtml/ch88'
 import XHTMLCH89 from '@/components/xhtml/ch89'
 import XHTMLCH90 from '@/components/xhtml/ch90'
 import XHTMLCH91 from '@/components/xhtml/ch91'
 import XHTMLCH92 from '@/components/xhtml/ch92'
 import XHTMLRGG from '@/components/xhtml/rgg'
 import XHTMLCH93 from '@/components/xhtml/ch93'
 import XHTMLFM02 from '@/components/xhtml/fm02'
 import XHTMLCH94 from '@/components/xhtml/ch94'
 import XHTMLCH95 from '@/components/xhtml/ch95'
 import XHTMLCH96 from '@/components/xhtml/ch96'
 import XHTMLCH97 from '@/components/xhtml/ch97'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLSS_US_ADULT_SIGNUP_BACK from '@/components/xhtml/SS_US_adult_signup_back'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/content",
 			"name" : "xhtml/content",
 			"component" : XHTMLCONTENT
 		},
 		{
 			"path" : "/xhtml/ded",
 			"name" : "xhtml/ded",
 			"component" : XHTMLDED
 		},
 		{
 			"path" : "/xhtml/half",
 			"name" : "xhtml/half",
 			"component" : XHTMLHALF
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
 		{
 			"path" : "/xhtml/ch02",
 			"name" : "xhtml/ch02",
 			"component" : XHTMLCH02
 		},
 		{
 			"path" : "/xhtml/ch03",
 			"name" : "xhtml/ch03",
 			"component" : XHTMLCH03
 		},
 		{
 			"path" : "/xhtml/ch04",
 			"name" : "xhtml/ch04",
 			"component" : XHTMLCH04
 		},
 		{
 			"path" : "/xhtml/ch05",
 			"name" : "xhtml/ch05",
 			"component" : XHTMLCH05
 		},
 		{
 			"path" : "/xhtml/ch06",
 			"name" : "xhtml/ch06",
 			"component" : XHTMLCH06
 		},
 		{
 			"path" : "/xhtml/ch07",
 			"name" : "xhtml/ch07",
 			"component" : XHTMLCH07
 		},
 		{
 			"path" : "/xhtml/ch08",
 			"name" : "xhtml/ch08",
 			"component" : XHTMLCH08
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js